"use client";

import AppModal from "components/Commons/AppModal/AppModal";
import AppNotice from "components/Commons/AppNotice/appNotice";
import SlideUp from "components/Commons/CommonSlideUp/slideUp";
import PageLoading from "components/Commons/PageLoading/PageLoading";
import WholePageLoading from "components/Commons/WholePageLoading/WholePageLoading";
import { SAVEIT_EASY_AUTH_MODE } from "config";
import { isAllowedUser, isInPeriodOf } from "helper/functionalHelper";
import appRoutes from "pages/AppInfo/AppRoutes";
import AppURLs from "pages/AppInfo/AppUrl";

import { useQueryClient } from "@tanstack/react-query";
import AppSelectModal from "components/Commons/AppModal/AppSelectModal";
import useAuthQuery from "globalQueries/useAuthQuery";
import { fetchUserReport } from "globalQueries/useSaveitReportQuery";
import useTimerQuery from "globalQueries/useTimerQuery";
import TokenStorage from "helper/apiService/TokenStorage";
import { AppQueryKey } from "helper/constant";
import { useSideBar } from "pages/Common/AppState";
import ErrorFallback from "pages/Common/ErrorFallback";
import MobileHeader from "pages/Common/MobileHeader";
import React, { Suspense, useEffect, useState } from "react";
import { getUA } from "react-device-detect";
import { ErrorBoundary } from "react-error-boundary";
import { Redirect, Route, Switch, useLocation } from "react-router-dom";
import "./MobileLandingNew.scss";

const MobileSidebar = React.lazy(() => import("pages/Common/MobileSidebar"));
const AuthMiddleware = React.lazy(() => import("pages/Common/AuthMiddleware"));
const ServiceUnAvailable = React.lazy(() =>
  import("pages/GeneralAnalysis/ServiceUnAvailable"),
);

const ios15Cover =
  "https://taxasone-drive.s3.ap-northeast-2.amazonaws.com/public/common/img_ios_inapp_cover.png";

const MobileLandingNew = () => {
  const { isFetched: isFetchedTimer, data: timeSetting } = useTimerQuery();
  const [isInAppIos15InApp, setIsIos15InApp] = useState(false);
  const { pathname } = useLocation();
  const { sideBarOpen } = useSideBar();
  const { userInfo } = useAuthQuery(true);
  const queryClient = useQueryClient();
  useEffect(() => {
    if (userInfo?.id) {
      queryClient.prefetchQuery({
        queryKey: [AppQueryKey.cit.reportList],
        queryFn: fetchUserReport,
      });
    }
  }, [userInfo?.id, queryClient]);

  useEffect(() => {
    if (SAVEIT_EASY_AUTH_MODE === "PASS") {
      if (
        getUA.match(
          /Snapchat|Line|WirtschaftsWoche|Thunderbird|Instagram|everytimeApp|WhatsApp|Electron|wadiz|AliApp|zumapp|kakaostory|band|twitter|DaumApps|DaumDevice\/mobile|FB_IAB|FB4A|FBAN|FBIOS|FBSS|SamsungBrowser\/[^1]/i,
        ) &&
        getUA.match(/iPhone|iPad/i)
      ) {
        setIsIos15InApp(true);
        return;
      }
    } else {
      if (
        getUA.match(
          /AHA|a-ha|Snapchat|WirtschaftsWoche|Thunderbird|Instagram|everytimeApp|WhatsApp|Electron|wadiz|AliApp|zumapp|kakaostory|band|twitter|DaumApps|DaumDevice\/mobile|FB_IAB|FB4A|FBAN|FBIOS|FBSS|SamsungBrowser\/[^1]/i,
        ) &&
        getUA.match(/iPhone|iPad/i)
      ) {
        setIsIos15InApp(true);
        return;
      }
    }
  }, [pathname]);

  if (isInAppIos15InApp) {
    return (
      <div className="mobile-wrapper">
        <div className="mobile-wrapper-left" />
        <div className="mobile-wrapper-center">
          <div className="mobile-landing-new-container pt-0">
            <img
              src={ios15Cover}
              alt=""
              style={{ width: "100%", height: "100%" }}
              // onClick={() => {
              //   window.open("https://app.thesave.it/", "_blank");
              // }}
            />
          </div>
        </div>
        <div className="mobile-wrapper-right" />
      </div>
    );
  }

  if (
    !isFetchedTimer ||
    !timeSetting ||
    (TokenStorage.isLoggedIn() && !userInfo.id)
  ) {
    return <WholePageLoading />;
  }

  if (
    isInPeriodOf(timeSetting.service) &&
    !isAllowedUser(timeSetting.service, userInfo.id)
    // && APP_BASE_URL !== "https://app.taxasone.com"
  ) {
    return (
      <div className="mobile-wrapper">
        <div className="mobile-wrapper-left" />
        <div className="mobile-wrapper-center">
          <div className="mobile-landing-new-container">
            <Switch>
              <Route path={AppURLs.common.serviceUnavailable}>
                <ServiceUnAvailable />
              </Route>
              <Redirect
                to={{
                  pathname: AppURLs.common.serviceUnavailable,
                  state: {
                    type: "service",
                  },
                }}
              />
            </Switch>
            <MobileHeader hasMenu={false} />
          </div>
        </div>
        <div className="mobile-wrapper-right" />
      </div>
    );
  }

  return (
    <div className="mobile-wrapper">
      <div className="mobile-wrapper-left" />
      <div className="mobile-wrapper-center" id="mobile-landing-container">
        {/* 런타임 에러 처리를 위해 추가 */}
        <ErrorBoundary
          fallbackRender={(fallbackProps) => (
            <ErrorFallback {...fallbackProps} />
          )}
        >
          <Switch>
            {appRoutes.map((route) => {
              const Component = route.component;
              return (
                <Route path={route.url} key={route.url} exact={route.exact}>
                  {route.needAuth ? (
                    <AuthMiddleware
                      forceLogin={route.forceLogin}
                      requireHomeTaxFetch={route.needHomeTaxFetch}
                    >
                      <Component />
                    </AuthMiddleware>
                  ) : (
                    <Component />
                  )}
                </Route>
              );
            })}
            <Redirect to={AppURLs.root} />
          </Switch>
          {sideBarOpen !== null && (
            <Suspense fallback={<span />}>
              <MobileSidebar />
            </Suspense>
          )}
          <MobileHeader hasMenu />
          <AppNotice />
          <SlideUp />
          <AppModal />
          <AppSelectModal />
        </ErrorBoundary>
      </div>
      <div className="mobile-wrapper-right" />
      <PageLoading />
    </div>
  );
};

MobileLandingNew.propTypes = {};

export default React.memo(MobileLandingNew);
